import API from 'services/AUTH_API';

export default function checkToken(token) {
  return API.request({
    method: 'GET',
    url: `/oauth/check_token?token=${token}`,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
